import { AboveRightBarTabs } from "slot-definitions"
import { Box, Card } from "@mui/material"
import { Tabs } from "lib/@components/tabs"

export function RightBarTabs() {
    return (
        <>
            <AboveRightBarTabs.Slot />
            <Card sx={{ mx: 0, my: 1, height: "100%", minHeight: 0, display: "flex", flexDirection: "column" }}>
                <Tabs
                    id="ScheduleRightBar"
                    tabHolder={<Box sx={{ px: 2, bgcolor: "background.neutral" }} />}
                    panelHolder={
                        <Box
                            sx={{
                                m: 1,
                                flex: 1,
                                minHeight: 0,
                                display: "flex",
                                flexDirection: "column",
                                overflowY: "auto",
                            }}
                        />
                    }
                />
            </Card>
        </>
    )
}
